import companyLogo from '@/images/logo.svg'
import Image from 'next/image'

export default function ResponsiveLogo() {
  return (
    <div className="w-[140px] text-black lg:w-[148px]">
      <Image src={companyLogo} alt="NextClinic" priority={true} />
    </div>
  )
}
